<template>
    <div class="store-tree">
        <!-- 搜索框 -->
        <el-input v-model="filterText" placeholder="搜索门店名称或ID" size="small" clearable style="margin-bottom: 10px;">
            <i slot="prefix" class="el-icon-search"></i>
        </el-input>

        <!-- 自定义树形组件 -->
        <div class="tree-container">
            <CustomTreeItem v-for="node in treeData" :key="node.I_门店Id" :filterText="filterText" :node="node" :clickedNodeId="clickedNodeId" @check="handleNodeCheck" @click="handleNodeClick" />
        </div>
    </div>
</template>

<script>
/* eslint-disable */ // 禁用整个文件的ESLint校验
import CustomTreeItem from './CustomTreeItem.vue'

export default {
    components: { CustomTreeItem },
    props: {
        treeData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            filterText: '',
            clickedNodeId: -1
        }
    },
    methods: {
        // 节点勾选事件
        handleNodeCheck(data) {
            if (data.checked || data.I_是否半选 == true) {
                this.clickedNodeId = data.node.I_门店Id
            }
            this.$emit('check', data)


            //递归勾选父节点（可选）
            // this.$nextTick(() => {
            //     this.递归查找所有父节点(data.node, this.treeData)
            // })
        },

        // 节点点击事件
        handleNodeClick(node) {
            // console.log('handleNodeClick---', node)
            if(node.I_是否半选 || node.checked){
                this.clickedNodeId = node.I_门店Id
                this.$emit('node-click', node)
            }
            
        },
    }
}
</script>

<style scoped>
.store-tree {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tree-container {
    flex: 1;
    overflow-y: auto;
}
</style>